// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mycontent {
  width: 100%;
  background-color: white;
  padding-left: 20px;
}

.list-group-item {
  border: unset !important;
  margin-left: 10px;
  border-left: 2px solid #DFDFDF !important;
  border-radius: 0;
}
.icon-sync:hover {
  cursor: pointer;
}

li::before {
  display: inline-block;
  content: "";
  position: relative;
  left: -21px;
  top: 42px;
  border-radius: 50% 50%;
  background-color: #FF2882;
  width: 8px;
  height: 8px;
}
@media (min-width: 768px) {
  li::before {
    top: 24px;
    left: calc(-1.25rem - 5px);
  }
}

li.leagueNotifications::before {
  background-color: red;
  width: 10px;
  height: 10px;
}

li.clubNotifications::before {
  background-color: #ff9900;
  width: 10px;
  height: 10px;
}

li.requests::before {
  background-color: rgb(0, 4, 255);
  width: 10px;
  height: 10px;
}

li.validations::before {
  background-color: rgb(187, 255, 0);
  width: 10px;
  height: 10px;
}

.card-header {
  background-color: white;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-body {
  padding: 0px;
}
@media (min-width: 568px) {
  .card-body {
    padding-left: 10px;
    padding-right: 10px;
  }
}
@media (min-width: 768px) {
  .card-body {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/dashboard-common/dashboard-common.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,wBAAA;EACA,iBAAA;EACA,yCAAA;EACA,gBAAA;AAAJ;AAKA;EACE,eAAA;AAHF;;AAKA;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;AAFF;AAIE;EAXF;IAYI,SAAA;IACA,0BAAA;EADF;AACF;;AAIA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,gCAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,kCAAA;EACA,WAAA;EACA,YAAA;AADF;;AAKA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,YAAA;AAFF;AAIE;EAHF;IAII,kBAAA;IACA,mBAAA;EADF;AACF;AAGE;EARF;IASI,qBAAA;IACA,sBAAA;EAAF;AACF","sourcesContent":["\n.mycontent {\n    width: 100%;\n    background-color: white;\n    padding-left: 20px;\n}\n\n.list-group-item {\n    border: unset !important;\n    margin-left: 10px;\n    border-left: 2px solid #DFDFDF !important;\n    border-radius: 0;\n    @media (min-width: 768px) {\n\n    }\n}\n.icon-sync:hover {\n  cursor: pointer;\n}\nli::before {\n  display: inline-block;\n  content: '';\n  position: relative;\n  left: -21px;\n  top: 42px;\n  border-radius: 50% 50%;\n  background-color: #FF2882;\n  width: 8px;\n  height: 8px;\n\n  @media (min-width: 768px) {\n    top: 24px;\n    left: calc(-1.25rem - 5px);\n  }\n}\n\nli.leagueNotifications::before{\n  background-color: red;\n  width: 10px;\n  height: 10px;\n}\n\nli.clubNotifications::before{\n  background-color: #ff9900;\n  width: 10px;\n  height: 10px;\n}\n\nli.requests::before{\n  background-color: rgb(0, 4, 255);\n  width: 10px;\n  height: 10px;\n}\n\nli.validations::before{\n  background-color: rgb(187, 255, 0);\n  width: 10px;\n  height: 10px;\n}\n\n\n.card-header {\n  background-color: white;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.card-body {\n  padding: 0px;\n\n  @media (min-width:568px) {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  @media (min-width:768px) {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
